export enum PROJECTS {
    // active_projects в porfolio-config, серты по введенному коду
    // до получения они не отображаются в портфолио
    EVENTS_WITH_CONDITION = 'events_with_condition',
    EVENTS_WITHOUT_CONDITION = 'events_without_condition',
    WEBINARS_WITH_CONDITION = 'webinars_with_condition',
    WEBINARS_WITHOUT_CONDITION = 'webinars_without_condition',
    EVENTS = 'events',
    WEBINAR_EVENTS = 'webinar_events',
    CERTS_WITHOUT_CONDITION = 'certs_without_condition',

    TEACHER_RESERVE = 'teacher_reserve',
}

// TO-DO: выпилить EVENTS и WEBINAR_EVENTS
export const CERTIFICATE_PROJECTS_SLUGS: string[] = [
    PROJECTS.EVENTS_WITH_CONDITION,
    PROJECTS.EVENTS_WITHOUT_CONDITION,
    PROJECTS.WEBINARS_WITH_CONDITION,
    PROJECTS.WEBINARS_WITHOUT_CONDITION,
    PROJECTS.EVENTS,
    PROJECTS.WEBINAR_EVENTS,
    PROJECTS.CERTS_WITHOUT_CONDITION,
    PROJECTS.TEACHER_RESERVE,
];
